import { StyleSheet } from 'aphrodite';
import { mention } from '../../../../web/styles/colors';
import { CssSelectors } from '../../../../web/styles/styles';

const campaignSelectorWidth = 345;

export const styleSheet = StyleSheet.create({
	accountAgeSelect: {
		width: 330,
	},
	calendar: {
		backgroundColor: mention,
		borderRadius: 8,
		boxSizing: 'border-box',
		overflow: 'auto',
		padding: 20,
		overflowY: 'hidden',
	},
	calendarContainer: {
		gridTemplateRows: 'auto 1fr',
	},
	calendarCardHeader: {
		fontSize: 12,
		...CssSelectors.allDescendants(
			{
				position: 'absolute',
				top: -8,
				right: -4,
			},
			'time'
		),
	},
	campaignSelectorContainer: {
		height: '100%',
		paddingLeft: 30,
		width: campaignSelectorWidth,
	},
	campaignTemplateCardDragging: {
		opacity: 0.95,
	},
	campaignTemplateCardDraggingOverDay: {
		opacity: 0.9,
	},
	container: {
		boxSizing: 'border-box',
		height: '100%',
		paddingTop: 30,
		width: '100%',
	},
	filtersContainer: {
		display: 'grid',
		gridGap: 10,
		gridTemplateColumns: 'repeat(auto-fit, minmax(200px,330px))',
		marginBottom: 10,
	},
	industrySelect: {
		width: 160,
	},
	newCampaignCta: {
		marginLeft: 24,
		maxHeight: 40,
		minHeight: 40,
	},
	row: {
		display: 'flex',
		height: '100%',
	},
	selectDisabled: {
		backgroundColor: '#EBEBE4',
	},
	subverticalSelect: {
		width: 315,
	},
	socialMediaIcon: {
		width: 15,
		marginRight: 5,
	},
	triggerContainer: {
		alignItems: 'center',
		display: 'flex',
		height: '100%',
	},
	triggerLabel: {
		borderRight: '1px solid rgb(216,216,216)',
		color: '#D1d1d1',
		fontSize: 12,
		height: '100%',
		letterSpacing: 1.1,
		paddingLeft: 10,
		paddingRight: 10,
		paddingTop: 24,
		textTransform: 'uppercase',
		width: 120,
	},
	triggerValue: {
		paddingLeft: 10,
	},
});
